import { APIError } from "../core/errors";
import {
  postApi,
  getApi,
  getApiErrorMypage,
  postApiErrorMypage,
} from "../utils/common";

// マイページ-お知らせ一覧データ取得
export const getNewsList = async (searchCondition) => {
  const urlPath = "/api/mypage/newslist/?";
  const searchParams = new URLSearchParams({ ...searchCondition });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, searchParams);
  }
};

// マイページ-お知らせ詳細データ取得
export const getNews = async (id) => {
  const urlPath = "/api/mypage/news/?";
  const searchParams = new URLSearchParams(id);
  try {
    const json = await getApi(urlPath + searchParams);
    if (Object.keys(json).length < 1) {
      throw new APIError("API Error", { status: 404 });
    }
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, searchParams);
  }
};

// マイページ-お知らせ既読登録
export const postAddNoticeRead = async (notice_id) => {
  const urlPath = "/api/mypage/news/addread/";
  const postData = { notice_id: notice_id };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorMypage(e, urlPath, postData);
  }
};
